// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "40775784","824": "ec43d10b","9347": "8377c8c5",}[chunkId] + ".css"
}